import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * 소셜 OAuth 로그인을 수행합니다. (Google, Kakao, Apple 등)
 * @param {{ provider: 'google' | 'kakao' | 'apple', redirectTo?: string }} params
 */
export async function signInWithOAuth({ provider, redirectTo }) {
  if (!isSupabaseConfigured) {
    return { data: null, error: new Error('Supabase 환경 변수가 설정되지 않았습니다.') };
  }

  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: redirectTo || `${window.location.origin}/`,
      },
    });

    if (error) {
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err instanceof Error ? err : new Error('소셜 로그인 중 오류가 발생했습니다.'),
    };
  }
}
